// extracted by mini-css-extract-plugin
export default {"title":"CreateKupon_title__ahEUq","input":"CreateKupon_input__md0fd","btn":"CreateKupon_btn__OnruT"};